import { render } from "./ProjectDialog.vue?vue&type=template&id=7a2d4da4"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__